import React from "react";

const columns = self => {
  return  [
    {
      name: 'id',
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "名称",
      name: "name",
      searchItem: {},
      tableItem: {
        width: 250
      },
    },
    {
      title: "说明",
      name: "intro",
      tableItem: {
        width: 475
      },
    },
    {
      title: "受众组",
      name: "groupScope",
      tableItem: {
        width: 150,
        render: (text, record) => <a onClick={(e) => self.handleLook(e,text)}>查看受众组</a>
      },
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'audienceGroup/listByPage',
    ...api
  }
}

const audienceGroup = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(self),
    tableApi: tableApi(api),
    searchProps: {},
  }
}

export default audienceGroup
